import { ReactElement } from 'react';
import { EmbeddedCompany } from 'types';
import { BoundState, Breadcrumb, ClientTitle } from 'components';
import { RowType, startColumns, endColumns, boundStateOptions } from './common';
import { CompanyFilterChip } from 'modules/core/company/components';
import { UserFilterChip } from 'components/filters/UserFilterChip';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';
import { AgencyActivityTypesFilterChip } from 'modules/campaign/common/AgencyActivityTypesFilterChip';
import { PeriodFilter } from './PeriodFilter';
import { ReportTable } from 'components/ReportTable';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

type IncomeRowType = RowType & {
  client: EmbeddedCompany;
  payer: EmbeddedCompany;
};

const columns: ControlledTableColumns<IncomeRowType> = [
  ...startColumns,
  flexColumn({
    key: 'client',
    content: 'Client',
    sortable: true,
    render: (row) => <ClientTitle {...row} />,
  }),
  ...endColumns,
  {
    key: 'state',
    configLabel: 'Status',
    width: 30,
    render: ({ state, is_overspent }) => <BoundState variant="income" state={state} is_overspent={is_overspent} />,
  },
];

export function IncomeLinks(): ReactElement {
  return (
    <ReportTable
      url="invoicing/links/income"
      columns={columns}
      filterFields={
        <>
          <Breadcrumb>Income</Breadcrumb>
          <UserFilterChip name="manager" filter={{ manage_campaign: true }} />
          <UserFilterChip name="planner" filter={{ plan_campaign_block: true }} />
          <AgencyActivityTypesFilterChip />
          <CompanyFilterChip name="client" />
          <SelectFilterChip name="state" options={boundStateOptions} />
          <PeriodFilter />
        </>
      }
    />
  );
}
